export default {
  inserted(el, binding) {
    // No reason to auto focus on mobile, as keyboard
    // is not trigged, and if it was, would take up 1/2 screen
    if (('ontouchstart' in document.documentElement) || !binding.value) return;
    el.focus();
  },
};
